import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "./StrengthCards.css";
import SectionLabel from "./SectionLabel";

const strengthCards = [
  {
    title: "MANUFACTURING",
    description: (
      <>
      State-of-the-Art Facility,
        <br />
        Being Established in &amp;
        <br />
       Bareilly, Uttar Pradesh
      </>
    ),
    icon: (
      <svg viewBox="0 0 64 64">
        <path d="M32 10L39 29L55 35L39 37L32 54L25 37L9 35L25 29Z" />
        <path d="M32 10V54" />
        <path d="M25 29L17 22" />
        <path d="M39 29L47 22" />
      </svg>
    ),
  },

  {
    title: "AI AT THE CORE",
    description: (
      <>
  From Acoustic       <br />
Classification to
        <br />
        &amp; Fire-Control Decision Support
      </>
    ),
    icon: (
      <svg viewBox="0 0 64 64">
        <path d="M10 34H54L48 44H16Z" />
        <path d="M20 34V27H43V34" />
        <path d="M27 27V21H39V27" />
        <path d="M12 46H20" />
        <path d="M44 46H52" />
        <circle cx="20" cy="45" r="4" />
        <circle cx="44" cy="45" r="4" />
      </svg>
    ),
  },

  {
    title: "MAKE IN INDIA",
    description: (
      <>
       Reducing Import,
        <br />
       Dependence  &amp;
        <br />
      Strengthening Sovereign Capability
      </>
    ),
    icon: (
      <svg viewBox="0 0 64 64">
        <path d="M8 40H56L48 48H16Z" />
        <path d="M19 40V31H45V40" />
        <path d="M25 31L32 23L39 31" />
        <path d="M32 16V23" />
        <path d="M10 53C15 49 20 57 25 53C30 49 35 57 40 53C45 49 50 57 55 53" />
      </svg>
    ),
  },

  {
    title: "  DUAL-DOMAIN FOCUS",
    description: (
      <>
       Across Gun Systems
        <br />
        &amp;  Underwater
        <br />
        Sensing Technologies
      </>
    ),
    icon: (
      <svg viewBox="0 0 64 64">
        <path d="M8 37H56L48 44H16Z" />
        <path d="M18 37V31H46V37" />
        <path d="M25 31L32 24L39 31" />
        <path d="M13 51C19 47 25 55 31 51C37 47 43 55 51 51" />
      </svg>
    ),
  },

  {
    title: "IN-HOUSE R&D",
    description: (
      <>
   Dedicated Engineering,
        <br />
       Teams Driving,
        <br />
     Continuous Innovation
      </>
    ),
    icon: (
      <svg viewBox="0 0 64 64">
        <rect x="15" y="15" width="34" height="34" rx="5" />
        <rect x="23" y="23" width="18" height="18" rx="2" />
        <path d="M10 24H15M10 32H15M10 40H15" />
        <path d="M49 24H54M49 32H54M49 40H54" />
        <path d="M24 10V15M32 10V15M40 10V15" />
        <path d="M24 49V54M32 49V54M40 49V54" />
      </svg>
    ),
  },


];

const StrengthCards = () => {
  const swiperRef = useRef(null);
  const sectionRef = useRef(null);

  /*
   * Start animation only when section enters viewport.
   */
  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add("strength-visible");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0.15,
      }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  /*
   * Arrow controls
   */
  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  return (
    <section
      ref={sectionRef}
      className="strength-section"
    >
      <div className="container strength-container g-0">

        {/* ================= HEADER ================= */}
        <div className="strength-header">

          <div className="strength-heading">

          <SectionLabel title="Our Strength" />

           <h2 className="section-heading">
              A MULTI-DOMAIN
              <br />
              DEFENCE ECOSYSTEM
            </h2>

          </div>

          <div className="strength-intro">

            <p className="section-subHeading">
              LNXT develops mission-critical systems across air, land,
              <br className="desktop-break" />
              surface and underwater domains using advanced engineering,
              <br className="desktop-break" />
              AI and deep domain expertise.
            </p>

            {/* ARROWS */}
            <div className="strength-arrows">

              <button
                type="button"
                className="strength-arrow strength-arrow-prev"
                onClick={handlePrev}
                aria-label="Previous slide"
              >
                &lt;
              </button>

              <button
                type="button"
                className="strength-arrow strength-arrow-next"
                onClick={handleNext}
                aria-label="Next slide"
              >
                &gt;
              </button>

            </div>

          </div>

        </div>

        {/* ================= SLIDER ================= */}
        <div className="strength-slider-wrapper">

          <Swiper
            className="strength-swiper"
            modules={[Autoplay]}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            slidesPerView={4}
            spaceBetween={8}
            speed={900}
            loop={true}
            grabCursor={true}
            watchSlidesProgress={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{

              /* Mobile */
              0: {
                slidesPerView: 1,
                spaceBetween: 14,
                centeredSlides: true,
              },

              /* Large Mobile */
              500: {
                slidesPerView: 1,
                spaceBetween: 16,
                centeredSlides: true,
              },

              /* Tablet */
              650: {
                slidesPerView: 2,
                spaceBetween: 12,
                centeredSlides: false,
              },

              /* Small Desktop */
              900: {
                slidesPerView: 3,
                spaceBetween: 12,
                centeredSlides: false,
              },

              /* Desktop */
              1150: {
                slidesPerView: 4,
                spaceBetween: 8,
                centeredSlides: false,
              },

              /* Large Desktop */
              1350: {
                slidesPerView: 4,
                spaceBetween: 12,
                centeredSlides: false,
              },
            }}
          >

            {strengthCards.map((card, index) => (
              <SwiperSlide key={`${card.title}-${index}`}>

                <div className="strength-card">

                  <div className="strength-card-icon">
                    {card.icon}
                  </div>

                  <h3 className="cards-title">
                    {card.title}
                  </h3>

                  <p className="cards-descp section-para">
                    {card.description}
                  </p>

                  {/* <Link
                    to="/contact"
                    className="strength-card-link"
                  >
                    VIEW SOLUTIONS
                    <span>→</span>
                  </Link> */}

                </div>

              </SwiperSlide>
            ))}

          </Swiper>

        </div>

      </div>
    </section>
  );
};

export default StrengthCards;